export default __webpack_public_path__ + "static/media/15-shine.f5bd1d46.png";